/**
 * @flow
 * @relayHash c26fa01eefbf0dceddd728fe2eba8edb
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type SetUserActiveWidgetInput = {
  userId: string,
  widgetId: string,
  clientMutationId?: ?string,
};
export type SetUserActiveWidgetMutationVariables = {|
  input: SetUserActiveWidgetInput
|};
export type SetUserActiveWidgetMutationResponse = {|
  +setUserActiveWidget: ?{|
    +user: ?{|
      +activeWidget: ?string
    |}
  |}
|};
export type SetUserActiveWidgetMutation = {|
  variables: SetUserActiveWidgetMutationVariables,
  response: SetUserActiveWidgetMutationResponse,
|};
*/


/*
mutation SetUserActiveWidgetMutation(
  $input: SetUserActiveWidgetInput!
) {
  setUserActiveWidget(input: $input) {
    user {
      activeWidget
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "SetUserActiveWidgetInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "SetUserActiveWidgetInput!"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "activeWidget",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "operationKind": "mutation",
  "name": "SetUserActiveWidgetMutation",
  "id": null,
  "text": "mutation SetUserActiveWidgetMutation(\n  $input: SetUserActiveWidgetInput!\n) {\n  setUserActiveWidget(input: $input) {\n    user {\n      activeWidget\n      id\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "SetUserActiveWidgetMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "setUserActiveWidget",
        "storageKey": null,
        "args": v1,
        "concreteType": "SetUserActiveWidgetPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "user",
            "storageKey": null,
            "args": null,
            "concreteType": "User",
            "plural": false,
            "selections": [
              v2
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "SetUserActiveWidgetMutation",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "setUserActiveWidget",
        "storageKey": null,
        "args": v1,
        "concreteType": "SetUserActiveWidgetPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "user",
            "storageKey": null,
            "args": null,
            "concreteType": "User",
            "plural": false,
            "selections": [
              v2,
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "id",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'b8842e2cd7d06c98b63f8634e1c13cb4';
module.exports = node;



// WEBPACK FOOTER //
// ./src/js/mutations/__generated__/SetUserActiveWidgetMutation.graphql.js